import $ from 'jquery';

let singleOpen = false;
let lastClicked = false;

const $archive_item = $('.archive__item'),
		$singleWrapper = $('.suppliers-map-popup__wrapper--suppliers'),
		$single = $('.suppliers-map-popup--suppliers'),
		$close = $('.suppliers-map-popup--close'),
		facets = $('.facetwp-facet:not(.facetwp-facet-maps)'),
		facets_search = $('.facetwp-type-search');

function showEmptyTriggers() {
	facets_search.each(function (i, el) {
		let value = $(el).find('.facetwp-search').val();
		if (value === undefined || value !== '') {
			$(el).parent().find('.suppliers-map__search--close').show();
			return;
		}
		$(el).parent().find('.suppliers-map__search--close').hide();
	});
}

facets.on('click', function () {
	$singleWrapper.slideUp();
	singleOpen = false;
})

facets_search.each(function (i, el) {

	$(el).on('keyup', function () {
		showEmptyTriggers();
	})

	$(el).parent().find('.suppliers-map__search--close').on('click', () => {
		let $searchInput = $(el).find('.facetwp-search');
		$searchInput.val('');
		$(el).parent().find('.suppliers-map__search--close').hide();
		$singleWrapper.slideUp();
		singleOpen = false;
		window.FWP_MAP.is_filtering = false;
		FWP.reset();
	});
})

$(document).keyup(function (e) {
	if (e.which === 27) {
		$singleWrapper.slideUp();
		$archive_item.removeClass('is-active');
		singleOpen = false;
	}
});

$close.on('click', () => {
	$singleWrapper.slideUp();
	$archive_item.removeClass('is-active');
	singleOpen = false;
});

document.addEventListener('facetwp-refresh', () => {
	$singleWrapper.slideUp();
	$archive_item.removeClass('is-active');
	singleOpen = false;
});

document.addEventListener('facetwp-loaded', () => {
	showEmptyTriggers();
});

if (typeof FWP !== 'undefined') {
	FWP.hooks.addAction('facetwp_map/marker/click', marker => {
		const post_id = marker.post_id;
		$archive_item.removeClass('is-active');

		$('.archive__item[data-id="' + post_id + '"]').addClass('is-active');

		$.ajax({
			method: "GET",
			url: "/wp-json/superunie/v1/suppliers_map_info/" + post_id,
		}).done(res => {
			const template = wp.template('supplier-single');
			const html = template({id: post_id, ...res.supplier});

			$single.html(html);

			if (marker.post_id === lastClicked && singleOpen) {
				$singleWrapper.slideUp();
				$archive_item.removeClass('is-active');
				singleOpen = false;
			} else {
				if (!singleOpen) {
					$singleWrapper.slideDown({
						start: () => {
							$singleWrapper.addClass('flex-container');
						}
					});
					singleOpen = true;
				}
			}

			lastClicked = marker.post_id;
		});

	});

	$('.suppliers-map__filters--reset').on('click', function () {
		FWP.reset();
	});
}

$('.suppliers-map').on('click', '.single__close-btn', function (e) {
	e.preventDefault();

	$singleWrapper.slideUp();
	$archive_item.removeClass('is-active');
	singleOpen = false;

	return false;
});

$('[data-trigger]').on('click', function () {
	$(this).toggleClass('active');
	$("[data-filter=" + $(this).data('trigger') + "]").toggle();
});

document.addEventListener("facetwp-loaded", () => {
	if (window.FWP.active_facet !== null) {
		const facet = FWP.active_facet;
		const dropdown = facet.find(".facetwp-dropdown").nodes[0];
		dropdown.fselect.close();
	}
});